import { put, takeLatest } from 'redux-saga/effects'
import { notification } from 'antd'
import i18next from 'i18next'
import {
  getCourseActivityUserList,
  getStudyCourseTime,
  getStudyCourseHistory,
  getCourseRankingAll,
  getCourseRankingNissoken,
  getCourseRankingCompany
} from '../../../apis'
import { updateBookmarkApi } from '../../../apis/course.api'
import {
  loadCourseActivityUserListSuccess,
  loadCourseActivityUserListError,
  loadStudyCourseTimeSuccess,
  loadStudyCourseTimeError,
  loadStudyCourseHistorySuccess,
  loadStudyCourseHistoryError,
  loadCourseRankingAllSuccess,
  loadCourseRankingAllError,
  loadCourseRankingNissokenSuccess,
  loadCourseRankingNissokenError,
  loadCourseRankingCompanySuccess,
  loadCourseRankingCompanyError,
  updateBookmarkSuccess,
  updateBookmarkError
} from './actions'
import {
  LOAD_COURSE_ACTIVITY_USER_LIST,
  LOAD_STUDY_COURSE_TIME,
  LOAD_STUDY_COURSE_HISTORY,
  LOAD_COURSE_RANKING_ALL,
  LOAD_COURSE_RANKING_NISSOKEN,
  LOAD_COURSE_RANKING_COMPANY,
  UPDATE_BOOKMARK
} from './constants'
import { REQUEST } from '../../../store'

export function* loadUserListSaga() {
  try {
    const { data } = yield getCourseActivityUserList()
    yield put(loadCourseActivityUserListSuccess(data))
  } catch (error) {
    yield put(loadCourseActivityUserListError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.user_list')
    })
  }
}

export function* loadStudyCourseTimeSaga({ payload }) {
  try {
    const { data } = yield getStudyCourseTime(payload)
    yield put(loadStudyCourseTimeSuccess(data))
  } catch (error) {
    yield put(loadStudyCourseTimeError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.viewing_time')
    })
  }
}

export function* loadStudyCourseHistorySaga({ payload }) {
  try {
    const { data } = yield getStudyCourseHistory(payload)
    yield put(loadStudyCourseHistorySuccess(data))
  } catch (error) {
    yield put(loadStudyCourseHistoryError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.viewing_history')
    })
  }
}

export function* loadCourseRankingAllSaga() {
  try {
    const { data } = yield getCourseRankingAll()
    yield put(loadCourseRankingAllSuccess(data))
  } catch (error) {
    yield put(loadCourseRankingAllError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.viewing_ranking_all')
    })
  }
}

export function* loadCourseRankingNissokenSaga() {
  try {
    const { data } = yield getCourseRankingNissoken()
    yield put(loadCourseRankingNissokenSuccess(data))
  } catch (error) {
    yield put(loadCourseRankingNissokenError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.viewing_ranking_nissoken')
    })
  }
}

export function* loadCourseRankingCompanySaga() {
  try {
    const { data } = yield getCourseRankingCompany()
    yield put(loadCourseRankingCompanySuccess(data))
  } catch (error) {
    yield put(loadCourseRankingCompanyError(error))
    notification.error({
      message: i18next.t('common.error'),
      description: i18next.t('course_activity.errors.viewing_ranking_company')
    })
  }
}

export function* updateBookmarkSaga({ payload }) {
  const { queryParam, item } = payload
  try {
    const { data } = yield updateBookmarkApi(queryParam)
    yield put(updateBookmarkSuccess({ data, item }))
  } catch (error) {
    yield put(updateBookmarkError(error))
  }
}

export default function* courseRankingSaga() {
  yield takeLatest(REQUEST(LOAD_COURSE_ACTIVITY_USER_LIST), loadUserListSaga)
  yield takeLatest(REQUEST(LOAD_STUDY_COURSE_TIME), loadStudyCourseTimeSaga)
  yield takeLatest(REQUEST(LOAD_STUDY_COURSE_HISTORY), loadStudyCourseHistorySaga)
  yield takeLatest(REQUEST(LOAD_COURSE_RANKING_ALL), loadCourseRankingAllSaga)
  yield takeLatest(REQUEST(LOAD_COURSE_RANKING_NISSOKEN), loadCourseRankingNissokenSaga)
  yield takeLatest(REQUEST(LOAD_COURSE_RANKING_COMPANY), loadCourseRankingCompanySaga)
  yield takeLatest(REQUEST(UPDATE_BOOKMARK), updateBookmarkSaga)
}
